export default __webpack_public_path__ + "static/media/BrutalType-Bold.790fbaea.ttf";